export default () => {
  class Modal {
    constructor(name) {
      this.body     = document.querySelector('body');
      this.modal    = document.querySelector(`.js-modal[id=${name}]`);
      this.openBtns = document.querySelectorAll(`[href='#${name}']`);
      this.closeBtn = this.modal.querySelector('.js-modal-close');

      this.openBtns.forEach(btn => {
        btn.addEventListener('click', e => {
          e.preventDefault();
          this.open();
        });
      });

      this.closeBtn?.addEventListener('click', () => {
        this.close();
      });

      this.modal.addEventListener('click', e => {
        if (e.target === e.currentTarget) {
          this.close();
        }
      });
    }

    open() {
      this.body.classList.add('open-modal');
      this.modal.classList.add('open');
      setTimeout(() => {
        this.modal.classList.add('fade');
      });
    }

    close() {
      this.body.classList.remove('open-modal');
      this.modal.classList.remove('fade');
      setTimeout(() => {
        this.modal.classList.remove('open');
      }, 500);
    }
  }

  let modals = document.querySelectorAll('.js-modal');

  modals.forEach(modal => {
    let name = modal.getAttribute('id');
    new Modal(name);
  });
}